import {
    PRELIMINARY_FAILED,
    PRELIMINARY_FETCHING,
    PRELIMINARY_SUCCESS,
    PRELIMINARY_FROM_SUCCESS,
    PRELIMINARY_FROM_STATUS

} from "../../Constants.ts";

export interface PreliminaryState {
    isFetching: boolean;
    isError: boolean;
    result: any;
    resultFrom: { data: [] },
    resultFromStatus: { data: [] },
}

const initialState: PreliminaryState = {
    isFetching: false,
    isError: false,
    result: null,
    resultFrom: { data: [] },
    resultFromStatus: { data: [] },
};

export default (state = initialState, { type, payload }: any): PreliminaryState => {
    switch (type) {
        case PRELIMINARY_FETCHING:
            return { ...state, isFetching: true, isError: false };
        case PRELIMINARY_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case PRELIMINARY_FROM_SUCCESS:
            return { ...state, isFetching: false, isError: false, resultFrom: payload };
        case PRELIMINARY_FROM_STATUS:
            return { ...state, isFetching: false, isError: false, resultFromStatus: payload };
        case PRELIMINARY_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
